import React from "react";
import { Deposits } from "../features";
import { Grid } from "@material-ui/core";

function DepositsPage() {
  return (
    <>
      <Deposits.Container />
    </>
  );
}

export default DepositsPage;
